import { CategoryData } from '../types/CategoryData.ts';
import { ChartContext } from './ChartContext';
import { Stakeholder } from './Stakeholder';
import {Category} from "./Category.ts";

export class Categories {

    private categories : Category[];

    constructor(
        private chartContext: ChartContext,
        private categoriesData: CategoryData[]
    ) {
        const angleStep = (2 * Math.PI) / this.categoriesData.length;

        this.categories = this.categoriesData.map((cat, i) => {
            const startAngle = -Math.PI / 2 + i * angleStep;
            const endAngle = startAngle + angleStep;

            // Calculate all stakeholder angles at once
            const stakeholderAngles = this.calculateStakeholderAngles(
                startAngle,
                endAngle,
                cat.stakeholdersData.length);

            const stakeholders = cat.stakeholdersData.map((stakeholder, index) => {
               return new Stakeholder(this.chartContext, stakeholder, stakeholderAngles[index]);
            });

            return new Category(this.chartContext, cat.name, startAngle, angleStep, stakeholders);
        });
    }

    private calculateStakeholderAngles(startAngle: number, endAngle: number, stakeholdersCount: number): number[] {
        const angles: number[] = [];
        const angleRange = endAngle - startAngle;
        
        // If there's only one stakeholder, place it in the middle
        if (stakeholdersCount === 1) {
            angles.push(startAngle + angleRange / 2);
            return angles;
        }

        // Distribute stakeholders evenly across the category
        for (let i = 0; i < stakeholdersCount; i++) {
            const angle = startAngle + (angleRange * (i + 1)) / (stakeholdersCount + 1);
            angles.push(angle);
        }

        return angles;
    }

    draw(): void {
       this.categories.forEach(category => category.draw());
    }
}